/* file description */

import { LCP_FIELD_KINDS } from '@/components/SEFieldWithModel/effects/consts';
// 为空的moduleID
export const EMPTY_MODULE_ID = '0';

export const TIP_MSG_MAP = {
  autoLineEditUpdateSuccess: '编辑成功！',
  autoLineEditUpdateError: '编辑失败！',
  autoLineEditDeleteSuccess: '删除成功！',
  autoLineEditDeleteError: '删除失败！',
};

export const ASSETMODELMAPPing: any = [
  ['longtext', LCP_FIELD_KINDS.STRING],
  ['id', LCP_FIELD_KINDS.STRING],
  ['bool', LCP_FIELD_KINDS.STRING],
  ['timestamp', LCP_FIELD_KINDS.STRING],
  ['decimal', LCP_FIELD_KINDS.STRING],
  ['text', LCP_FIELD_KINDS.STRING],
  ['array', LCP_FIELD_KINDS.STRING],
  ['reference', LCP_FIELD_KINDS.REFERENCE],
  ['timestamp', LCP_FIELD_KINDS.DATE_TIME],
  ['integer', LCP_FIELD_KINDS.STRING],
  ['json', LCP_FIELD_KINDS.STRING],
];
